import Badge from 'src/components/Badge';
import { SiteDeviceNodeStatus as Status } from '../../types';

type StatusMapItem = {
    color?: 'success' | 'info' | 'error' | 'warning';
    label: string;
};

type Props = {
    value?: Status | string;
};

function NodeItemStatus({ value }: Props) {
    const statusMap: Record<Status, StatusMapItem> = {
        [Status.Ready]: { color: 'success', label: Status.Ready },
        [Status.Healthy]: { color: 'success', label: Status.Healthy },
        [Status.InProgress]: { color: 'info', label: Status.InProgress },
        [Status.Unknown]: { color: 'warning', label: Status.Unknown },
        [Status.Unavailable]: { color: 'warning', label: Status.Unavailable },
    };

    const normalizedStatusMap: Record<string, StatusMapItem> = Object.entries(statusMap).reduce(
        (acc, [key, statusItem]) => ({ ...acc, [key.toLowerCase()]: statusItem }),
        {}
    );

    const statusItem = value
        ? normalizedStatusMap[value.toLowerCase()] ?? { label: value }
        : statusMap[Status.Unavailable];

    return (
        <>
            <Badge {...statusItem} />
        </>
    );
}

export default NodeItemStatus;